import { Language } from 'components/common/types'
import validator from 'validator'

export default class InteractiveSignInRequired extends Error {
  constructor() {
    super()
    this.name = 'InteractiveSignInRequired'
  }
}

export const maxRecordsPerApiRequest = 1000 // max number of records that can be returned by azure at a time
export const recordsPerPage = 100 // must be divisible by maxRecordsPerApiRequest (whatever is the max amount azure can send back)
export const maxKeyNameLength = 17 // length of Key name should not exceed 17 characters

/**
 * Check if the value is valid. It uses the validator library to check if the value is alphanumeric and if it contains commas.
 * If the value contains any special characters (expect for allowedChars) or commas, it is invalid and returns false.
 * if the value contains only alphanumeric characters and allowedChars and does not contain commas, it is valid and returns true.
 *
 * @param {string} value
 * @return {*}  {boolean}
 */
export const isValidInput = (value: string, allowedChars: string): boolean => {
  return (
    validator.isAlphanumeric(validator.blacklist(value, allowedChars)) &&
    !validator.contains(value, ',')
  )
}

export const isObjectNotEmpty = (obj = {}) => {
  return obj && Object.keys(obj).length > 0
}

/**
 * Calculates the page number based on the total number of records.
 * @param {number} length - The total number of records.
 * @returns {number} The calculated page number.
 */
export const GetPageNum = (length: number): number => {
  return length === 0
    ? 1
    : Math.floor((length - 1) / maxRecordsPerApiRequest) *
        (maxRecordsPerApiRequest / recordsPerPage) +
        1
}

export const supportedLanguages: Language[] = [
  { value: 'en', label: 'English', disabled: false },
  { value: 'de', label: 'German', disabled: true },
  { value: 'es', label: 'Spanish', disabled: true },
  { value: 'fr', label: 'French', disabled: true },
  { value: 'ja', label: 'Japanese', disabled: true },
  { value: 'pt_BR', label: 'Portuguese (Brazil)', disabled: true },
  { value: 'pt_PT', label: 'Portuguese (Portugal)', disabled: true },
  { value: 'zh_HANS', label: 'Chinese (Simplified)', disabled: true },
  { value: 'zh_HANT', label: 'Chinese (Traditional)', disabled: true },
  { value: 'ko', label: 'Korean', disabled: true },
  { value: 'it', label: 'Italian', disabled: true },
  { value: 'ru', label: 'Russian', disabled: true },
  { value: 'fi', label: 'Finnish', disabled: true },
  { value: 'sv', label: 'Swedish', disabled: true },
  { value: 'nb_NO', label: 'Norwegian', disabled: true },
  { value: 'tr', label: 'Turkish', disabled: true },
  { value: 'ar', label: 'Arabic', disabled: true },
  { value: 'hu', label: 'Hungarian', disabled: true },
  { value: 'pl', label: 'Polish', disabled: true },
  { value: 'da', label: 'Danish', disabled: true },
  { value: 'nl', label: 'Dutch', disabled: true },
  { value: 'el', label: 'Greek', disabled: true },
  { value: 'th', label: 'Thai', disabled: true },
  { value: 'lt', label: 'Lithuanian', disabled: true },
  { value: 'lv', label: 'Latvian', disabled: true },
  { value: 'et', label: 'Estonian', disabled: true },
  { value: 'bg', label: 'Bulgarian', disabled: true },
  { value: 'hr', label: 'Croatian', disabled: true },
  { value: 'cs', label: 'Czech', disabled: true },
  { value: 'he', label: 'Hebrew', disabled: true },
  { value: 'ro', label: 'Romanian', disabled: true },
  { value: 'sr', label: 'Serbian', disabled: true },
  { value: 'sk', label: 'Slovak', disabled: true },
  { value: 'sl', label: 'Slovenian', disabled: true },
  { value: 'uk', label: 'Ukrainian', disabled: true },
]
